import { render, staticRenderFns } from "./peasants.vue?vue&type=template&id=1cb5ac8c&scoped=true&"
import script from "./peasants.vue?vue&type=script&lang=js&"
export * from "./peasants.vue?vue&type=script&lang=js&"
import style0 from "./peasants.vue?vue&type=style&index=0&id=1cb5ac8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb5ac8c",
  null
  
)

export default component.exports